import { Layout } from "@/components/layout/Layout";
import { StoreBadges } from "@/components/common/StoreBadges";
import { DemoSEO } from "@/components/demo/DemoSEO";
import { DemoVideo } from "@/components/demo/DemoVideo";
import { DEMO_VIDEO_4K_SRC } from "@/components/demo/demo-seo-data";
import { useLanguage } from "@/lib/i18n";
import { translations } from "@/lib/translations";

/**
 * Demo video page (/demo, /en/demo).
 *
 * Deliberately NOT linked from the header or footer navigation: it is a direct
 * link shared with press and Apple.
 */
const Demo = () => {
  const { language } = useLanguage();
  const t = translations[language].demo;

  return (
    <Layout>
      <DemoSEO />
      <section className="relative flex min-h-svh flex-col overflow-hidden bg-background noise-bg sm:h-svh sm:min-h-[640px]">
        {/* Emerald glow from the bottom, same treatment as the home hero */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 70% 50% at 50% 100%, hsl(var(--primary) / 0.14) 0%, transparent 70%)",
          }}
        />
        {/* Fine dot-grid overlay */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, hsl(var(--foreground) / 0.07) 1px, transparent 0)",
            backgroundSize: "32px 32px",
          }}
        />

        <div className="container relative z-10 mx-auto flex min-h-0 flex-1 flex-col px-4 pb-8 pt-20 sm:px-6 sm:pt-28 lg:px-8">
          <header className="mx-auto max-w-2xl text-center">
            <h1 className="font-heading text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              {t.title}
            </h1>
            <p className="mx-auto mt-3 max-w-xl text-base text-muted-foreground sm:text-lg">
              {t.subtitle}
            </p>
          </header>

          {/* Takes whatever vertical space is left over */}
          <div className="mt-6 flex min-h-0 flex-1 justify-center">
            <DemoVideo />
          </div>

          <div className="mt-2 text-center">
            <a
              href={DEMO_VIDEO_4K_SRC}
              download="refound-demo-4k.mp4"
              className="text-xs text-muted-foreground/70 underline underline-offset-4 transition-colors hover:text-foreground"
            >
              {t.download4k}
            </a>
          </div>

          <div className="mt-3 text-center">
            <StoreBadges location="demo_page" />
            <p className="mt-1 text-sm font-medium tracking-wide text-muted-foreground/70">
              {t.freeNote}
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Demo;
